import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Profits } from './profit.model';
import { ProductCardsInventory } from './productcardsinventory/productcardsinventory.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {


  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {

  }


  getAllByDate(fromDate: any, toDate: any, name: string, getTotals: boolean, pageNo: number, pageSize: number) {
    return this.http.get<any>(this.global.APIURL + "reports/getbydate?" + "fromDate=" + fromDate +
      "&toDate=" + toDate + "&name=" + name + "&getTotals=" + getTotals +
      "&PageNumber=" + pageNo + "&PageSize=" + pageSize);
  }

  getByOrderId(orderId: number) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbyorderid?orderId=" + orderId);
  }

  getAllDirectCharged(fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbydirectCharged?" + "fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getByUser(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbyuser?userId=" + userId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllByCategory(categoryId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbycategoryanddate?categoryId=" + categoryId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllBySubCategory(subCategoryId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbysubcategoryanddate?subCategoryId=" + subCategoryId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllByProduct(productId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbyproductanddate?productId=" + productId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getMandoobStatment(id: string, fromDate: any, toDate: any, categoryId: number) {
    return this.http.get<any>(this.global.APIURL + "reports/mandoobstatment/" + id +
      "?fromDate=" + fromDate + "&toDate=" + toDate + "&categoryId=" + categoryId);
  }

  getAllCustomers(userId: string) {
    return this.http.get<[]>(this.global.APIURL + "users/customerlist/" + userId);
  }

  getUserTrans(userId: string, fromDate: any, toDate: any, transType: number) {
    return this.http.get<[]>(this.global.APIURL + "usertransbydateweb/" + userId + "?fromDate=" + fromDate
      + "&toDate=" + toDate + "&transType=" + transType);
  }

  getUserTransForMandoob(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "usertransformandoobbydate/" + userId + "?fromDate=" + fromDate
      + "&toDate=" + toDate);
  }

  getProfits(productId: number, fromDate: any, toDate: any, basicPrice: number) {
    return this.http.get<Profits>(this.global.APIURL + "reports/getprofits?productId="
      + productId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&basicPrice=" +
      basicPrice);
  }

  getProductCards(productId: number, status: number) {
    return this.http.get<[]>(this.global.APIURL + "reports/productcards?productId=" + productId
      + "&status=" + status);
  }

  userTransAll(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/usertransallreport?userId=" + userId + "&fromDate=" +
      fromDate + "&toDate=" + toDate);
  }

  getServicePayOrders(fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/servicepayorders?&fromDate=" +
      fromDate + "&toDate=" + toDate);
  }

  getMandoobsCustomersDeposit(mandoobId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "usertrans/mandoobcustomerdeposits?mandoobid=" +
      mandoobId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getProductCardsInventory(productId: number, fromDate: any, toDate: any) {
    return this.http.get<ProductCardsInventory>(this.global.APIURL + "reports/productcardsinventorybyproduct?productId=" +
      productId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

}
